<template>
  <div v-if="item" @click="goBack(item)" class="itemBox">
    <div class="title">
      <span :style="{ color: item.color }" class="custom-title">{{
        item.content || '--'
      }}</span>
    </div>
    <div class="desc">
      <span style="flex:2.5;" class="custom-titl"><img src="../../assets/img/txUserIcon.png" alt="" />{{ (item.rater)
      }}</span>
      <span style="flex:2;" class="custom-titl"><img src="../../assets/img/dateIcon.png" alt="" />{{
        formatDateTimeMM(item.ratingTime)
      }}
      </span>
      <span style="flex:2;" class="custom-titl">分数：{{
        item.score
      }}
      </span>
      <!-- <van-button @click="handleUrl(item)" size="mini">查看交易地址</van-button> -->
    </div>
    <!-- <div class="desc"> -->
    <!-- <span class="custom-titl">作者：{{ item.author }}</span> -->
    <!-- <span class="custom-titl">{{ getTimeShow(item.lastupdatetime) }}</span> -->
    <!-- <span class="custom-titl">浏览：{{ item.browsecount }}</span>
        <span class="custom-titl">回复：{{ item.replycount }}</span> -->
    <!-- </div> -->
  </div>
</template>
<script>
import { getTimeShow, isNewPlate, formatDateTimeMM, replaceStr } from '@/utils/index';
import { subscribe, cancelSubscribe } from '@/api/base';
export default {
  props: ['item', 'type'],
  methods: {
    getTimeShow,
    isNewPlate,
    formatDateTimeMM,
    replaceStr,
    goBack(item) {
      // if (this.type == 2) {
      //   this.$router.push({
      //     path: '/postView',
      //     query: {
      //       href: encodeURIComponent(encodeURIComponent(item.topicUrl)),
      //       section: item.section,
      //       title: item.title,
      //       type: item.type,
      //       author: item.author,
      //       date: item.lastupdatetime,
      //     },
      //   });
      //   return;
      // }
      this.$router.push({
        path: '/postView',
        query: {
          href: encodeURIComponent(encodeURIComponent(item.tradeUrl)),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.itemBox {
  background: #fff;
  margin-top: 10px;
  padding: 10px 20px;
  box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);

  .newIcon {
    display: block;
    width: 13px;
    height: 20px;
    margin-right: 8px;
  }
}

.itemBox .title {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 16px;
  padding-right: 40px;
}

.itemBox .follow {
  position: absolute;
  display: block;
  right: 0px;
  top: -10px;
  padding: 10px;
}

.itemBox .custom-title {
  margin-left: 10px;
  white-space: nowrap;
  /* 规定文本是否折行 */
  overflow: hidden;
  /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  flex: 1;
}

.itemBox .desc {
  width: 100%;
  margin-top: 5px;
  display: flex;
  color: #808080;
  font-size: 12px;
  justify-content: space-around;
  align-items: center;
}

.itemBox .desc:first-child {
  margin-top: 10px;
}

.desc .custom-titl {
  flex: 1;
  display: flex;
  white-space: nowrap;
  /* 规定文本是否折行 */
  overflow: hidden;
  /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  align-items: center;
  gap: 6px;

  img {
    display: block;
    width: 16px;
    height: 16px;
  }
}

.desc .custom-titl:last-child {
  justify-content: flex-end;
}
</style>